import React from 'react';

import { IMfaSessionDetails } from 'src/apps/mfa/services/MfaDashboardServiceTypes';
import { DashboardTableLabel } from 'src/common/components/DashboardTableLabel/DashboardTableLabel';
import { IReportInfo } from 'src/common/components/report-info/ReportInfo';
import { formatShortMonthDatetime } from 'src/common/helpers/DateFormatHelper';
import { applyMobileLabelDisplayNames } from 'src/common/helpers/LabelDisplayHelpers';

import './MfaSingleSessionHeader.scss';

const SESSION_LABELS_MAX_WIDTH = 440;

export const getMfaInfoItems = (
	unitIdDisplayName?: string,
	environmentDisplayName?: string
): IReportInfo[] => {
	return [
		{
			key: 'lastModified',
			label: 'Last modified',
			textFormatter: formatShortMonthDatetime
		},
		{
			key: 'owner',
			label: 'Owner'
		},
		{
			key: 'labels',
			label: 'Session labels',
			maxWidth: SESSION_LABELS_MAX_WIDTH,
			customValueRenderer: (session: IMfaSessionDetails) => {
				const labels = session.labels ?? [];
				return (
					<DashboardTableLabel
						labels={applyMobileLabelDisplayNames(labels, unitIdDisplayName, environmentDisplayName)}
						isWide
					/>
				);
			}
		}
	];
};
